import VueCookie from 'vue-cookies'

let USERINFO = 'USERINFO'
let USERINFOS = 'USERINFOS'
let USERCODE = 'USERCODE'
let STATUS = 'STATUS'
/**
 * @method          设置cookie
 * @param key    名称
 */
function setCookie(c_name, value, expire) {
    var date = new Date()
    date.setSeconds(date.getSeconds() + expire) //
    document.cookie = c_name + '=' + escape(value) + '; expires=' + date.toGMTString()
}

/**
 * @method          设置cookie
 * @param key    名称
 */
function getCookie(key) {
    let info = VueCookie.get(
        key
    );
    return JSON.parse(info)
}
export {
    VueCookie,
    USERINFO,
    USERINFOS,
    USERCODE,
    STATUS,
    setCookie,
    getCookie,
}


// WEBPACK FOOTER //
// ./src/cookie/cookie.js